export default {
  name: "BolideLoader"
};
